/**
 * Shared constants used across the backoffice application.
 * Centralized here to avoid duplication and ensure consistency.
 */

/**
 * Job role options for dropdowns throughout the application.
 * Used in: User management, Team members, Workflow templates, Form builder, etc.
 */
export const JOB_ROLE_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'administrator', label: 'Administrator' },
  { value: 'manager', label: 'Manager' },
  { value: 'partner', label: 'Partner' },
  { value: 'accountant', label: 'Accountant' },
  { value: 'sales', label: 'Sales' },
  { value: 'purchase', label: 'Purchase' },
  { value: 'client', label: 'Client' },
  { value: 'others', label: 'Others' },
];

/** Job role values as a simple string array */
export const JOB_ROLE_VALUES = JOB_ROLE_OPTIONS.map((o) => o.value);
